<script>
    import Highcharts from 'highcharts';
    import { onMount } from 'svelte';
    // import exportingInit from "highcharts/modules/exporting";
    // exportingInit(Highcharts);
    export let chartOptions;

    let container;
    let chart;

    onMount(() => {
        chart = Highcharts.chart(container, chartOptions);
    });
</script>

<div class="space-y-4">
    <!-- Chart Container -->
    <div bind:this={container} class="w-full h-[400px]"></div>
</div>
